import React, { FC } from 'react';
import ErrorLoadingDetailProperty from 'components/shared/detail/ErrorLoadingDetailProperty';
import AssignedTask from 'components/shared/detail/assignedUsersView/AssignedTask';
import Skeleton from 'react-loading-skeleton';
import { UserAssignedToPost } from 'types/User';

type Props = {
  isLoading?: boolean;
  isError?: boolean;
  assignedUsers?: UserAssignedToPost[];
  userId: number;
  onTaskToggle(assignedUser: UserAssignedToPost): void;
};

const AssignedUsersView: FC<Props> = ({
  isLoading,
  isError,
  assignedUsers,
  userId,
  onTaskToggle,
}) => {
  return (
    <div>
      {isLoading && <Skeleton height={60} />}
      {isError && <ErrorLoadingDetailProperty />}
      {!!assignedUsers?.length && (
        <>
          <div
            className="tw-relative tw-mb-3 tw-whitespace-break-spaces tw-rounded-md tw-bg-blue-alt-light tw-p-4 tw-text-sm after:tw-absolute after:tw-left-0 after:tw-top-0 after:tw-block after:tw-h-full after:tw-w-1 after:tw-rounded-sm after:tw-bg-primary-100 after:tw-content-[''] "
            data-cy="post-preview_assigned-task-text"
          >
            {assignedUsers[0].task.text.length
              ? assignedUsers[0].task.text
              : 'No description provided'}
          </div>
          <div className="tw-max-h[30vh] tw-relative tw-overflow-auto">
            {assignedUsers.map((assignedUser) => (
              <AssignedTask
                canEditStatus={userId === assignedUser.id}
                key={assignedUser.task.id + assignedUser.id}
                assignedUser={assignedUser}
                onToggle={onTaskToggle}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default AssignedUsersView;
